export default __webpack_public_path__ + "static/media/github.b966b53c.svg";